import React from 'react';
import { NavLink } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './ServiceReferenceSection.css';
import { WebDevIcon, AppDevIcon, UiUxIcon } from './ServiceReferenceIcons';

const serviceCardsData = [
  {
    Icon: WebDevIcon,
    alt: "Web Entwicklung",
    title: "Web Entwicklung",
    description:
      "Moderne und maßgeschneiderte Web-Lösungen, die Ihre Online-Präsenz stärken und Ihr Geschäft digital voranbringen.",
    link: "/services/web-development",
  },
  {
    Icon: AppDevIcon,
    alt: "App Entwicklung",
    title: "App Entwicklung",
    description:
      "Innovative App-Entwicklungen, die ein nahtloses Nutzererlebnis und höchste Performance auf mobilen Endgeräten garantieren.",
    link: "/services/app-development",
  },
  {
    Icon: UiUxIcon,
    alt: "UI/UX Design",
    title: "UI/UX Design",
    description:
      "Kreatives UI/UX Design, das Ihre Marke hervorhebt und eine intuitive Benutzerführung schafft.",
    link: "/services/ui-ux-design",
  },
];

const ServiceReferenceSection = () => {
  return (
    <section className="service-reference-section">
      <div className="service-reference-container">
        <h2 className="service-reference-title">Unsere Leistungen</h2>

        <Swiper
          modules={[Pagination]}
          spaceBetween={30}
          pagination={{ clickable: true }}
          breakpoints={{
            // When window width is >= 1024px
            1024: {
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
            // When window width is >= 768px
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            // When window width is < 768px
            0: {
              slidesPerView: 1,
              slidesPerGroup: 1,
            },
          }}
          className="service-reference-swiper"
        >
          {serviceCardsData.map((card, index) => (
            <SwiperSlide key={index}>
              <div className="service-reference-card">
                <div className="service-reference-logo">
                  <card.Icon />
                </div>
                <h3 className="service-reference-card-title">{card.title}</h3>
                <p className="service-reference-card-description">
                  {card.description}
                </p>
                <NavLink to={card.link} className="service-reference-button">
                  <i className="bi bi-arrow-right-short"></i>
                </NavLink>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ServiceReferenceSection;